import React from "react";
import {
  StyledDescription,
  StyledIndicators,
  StyledSectionWrapper,
  StyledImageWrapper,
  StyledContentWrapper
} from "./ui";

const Cases = () => {
  return (
    <StyledSectionWrapper>
      <StyledContentWrapper>
        <StyledIndicators display={["flex", "none"]}>
          <p>Teachers & Classes</p>
          <h3>Sports & Activities</h3>
          <p>Leagues & Tournaments</p>
        </StyledIndicators>

        <StyledDescription>
          <h4>Playing sports and activities never easier</h4>
          <p>Discover sports in your area and beyond.</p>
        </StyledDescription>

        <StyledImageWrapper>
          <StyledIndicators display={["none", "flex"]}>
            <p>Teachers & Classes</p>
            <h3>Sports & Activities</h3>
            <p>Leagues & Tournaments</p>
          </StyledIndicators>

          <img src="./images/section3-phons-desctop.png" />
        </StyledImageWrapper>
      </StyledContentWrapper>
    </StyledSectionWrapper>
  );
};

export default Cases;
